module.exports = __webpack_public_path__ + "img/funnel-control.e8091755.svg";